import { onFontsReady } from "../utils/onFontsReady";
import { initFontsGate } from "../utils/initFontsGate";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
initFontsGate("Manrope", [400, 700]);

function initProductsText(wrapper) {
  if (!wrapper || wrapper.dataset.gsapProductsSectionInited) return;
  wrapper.dataset.gsapProductsSectionInited = "1";

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const title = wrapper.querySelector(".products-section-title");
  const desc = wrapper.querySelector(".products-section-description");
  const slider = wrapper.querySelector(".wv-block-products .slider-container");

  if (slider) gsap.set(slider, { opacity: 0 });
  if (title) gsap.set(title, { opacity: 0, y: 14 });
  if (desc) gsap.set(desc, { opacity: 0, y: 10 });

  if (!title && !desc && !slider) return;

  const tl = gsap.timeline({
    defaults: { ease: "power2.out" },
    scrollTrigger: {
      trigger: wrapper,
      start: "top 80%",
      once: true,
      invalidateOnRefresh: true,
    },
  });

  if (title) {
    tl.to(title, {
      y: 0,
      opacity: 1,
      duration: 0.55,
      clearProps: "transform,opacity",
    });
  }

  if (desc) {
    tl.to(
      desc,
      {
        y: 0,
        opacity: 1,
        duration: 0.45,
        clearProps: "transform,opacity",
      },
      "-=0.25"
    );
  }

  if (slider) {
    tl.to(
      slider,
      {
        opacity: 1,
        duration: 0.8,
        ease: "power1.out",
        clearProps: "opacity",
      },
      "-=0.15"
    );
  }
}

function initProductsSwiper(wrapper) {
  const sliderEl = wrapper.querySelector(".wv-block-products .slider-container");
  if (!sliderEl || sliderEl.dataset.swiperInited) return;
  sliderEl.dataset.swiperInited = "1";

  const swiper = new Swiper(sliderEl, {
    loop: true,
    slidesPerView: 4,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    spaceBetween: 20,
    speed: 3500,
    grabCursor: true,
    pagination: {
      el: sliderEl.querySelector(".swiper-pagination"), // важно: внутри конкретного слайдера
      clickable: true,
    },
    breakpoints: {
      320: { slidesPerView: 1, spaceBetween: 0, centeredSlides: true },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
      1495: { slidesPerView: 4 },
    },
    on: {
      init: () => ScrollTrigger.refresh(),
      resize: () => ScrollTrigger.refresh(),
    },
  });

  // hover pause/resume — вешаем на область блока
  const hoverArea = wrapper.querySelector(".wv-block-products") || sliderEl;

  hoverArea.addEventListener("mouseenter", () => {
    swiper.autoplay?.stop(); // stop/start для обычного autoplay
  });

  hoverArea.addEventListener("mouseleave", () => {
    swiper.autoplay?.start();
  });
}

onFontsReady(() => {
  document.querySelectorAll(".wv-gsap-products-section").forEach((wrapper) => {
    initProductsSwiper(wrapper);
    initProductsText(wrapper);
  });

  ScrollTrigger.refresh();
});
